/* eslint-disable no-param-reassign */
/* eslint-disable no-new */
import Vue, { ref } from 'vue'

import adaptiveTable from '@components/widgets/adaptiveTable.vue'
import useHeaderCityObserver from '@hooks/useHeaderCityObserver'
import useTariffsMap from '@hooks/useTariffsMap'

Vue.config.productionTip = false

// Все данные и вёрстка в protected/views/site/tarify.php

new Vue({
  el: '#tarify',
  setup() {
    const cities = JSON.parse(document.getElementById('cities').value)
    const userCityId = document.getElementById('userCityId').value
    const selectedCity = ref(cities[userCityId])
    const { detailsShow, ...tariffsMapData } = useTariffsMap(selectedCity)

    detailsShow.value = selectedCity.value.alias

    return {
      detailsShow,
      cities,
      selectedCity,
      ...tariffsMapData,
    }
  },
  data() {
    return {
      uid: '',
      tarifsIntercity: [],
      shortCities: [1, 2, 3],
    }
  },
  components: {
    adaptiveTable,
  },
  computed: {
    isShortCity() {
      return this.shortCities.includes(+this.selectedCity.id)
    },
    cityAlias() {
      return this.selectedCity.alias
    },
    cityId() {
      return this.selectedCity.id
    },
  },
  created() {
    // берем из параметров шаблона user id, т.к. там всегда есть id текущего пользователя
    const idData = document.getElementById('id')

    if (idData) this.uid = idData.value

    const strTarifsIntercity = document.getElementById('tarifsIntercity').value

    this.tarifsIntercity = JSON.parse(strTarifsIntercity)

    this.isMobileView = !(window.innerWidth > 992)
    this.isShowPropBlock = false

    Object.keys(this.cities).forEach(key => {
      this.cities[key].tarifs.forEach(log => {
        log.weight = `<span class='one-text'>До ${log.weight} кг</span>`
        log.priceNonExpress = `<span class='one-text'>${log.priceNonExpress} ₽</span>`
        log.priceExpressShort = `<span class='important-text one-text'>${log.priceExpressShort} ₽</span>`
        log.price = `<span class='one-text'>${log.price} ₽</span>`
        log.priceExpress = `<span class='one-text'>${log.priceExpress} ₽</span>`
        log.prigorodPrice = `<span class='one-text'>${log.prigorodPrice} ₽</span>`
        log.prigorodExpress = `<span class='one-text'>${log.prigorodExpress} ₽</span>`
      })

      this.cities[key].tarifsPickup.forEach(log => {
        log.weight = `<span class='one-text'>до ${log.weight} кг</span>`
        log.price = `<span class='one-text'>${log.price} ₽</span>`
      })
    })

    useHeaderCityObserver(cityId => this.changeCity(cityId))
  },

  methods: {
    changeCity(id) {
      this.selectedCity = this.cities[id]
      this.detailsShow = this.selectedCity.alias
      window.setSessionCity(id, false) // Меняем город в шапке
    },
  },
})
